









































import Vue from 'vue';
import { mapActions, mapGetters } from 'vuex';
import { BCard } from 'bootstrap-vue';

import { Block } from '../types';
import AttributeCheckboxes from './AttributeCheckboxes.vue';
import FilterInput from './FilterInput.vue';
import ObjectTypeDropdown from './ObjectTypeDropdown.vue';
import RelatedFilters from './RelatedFilters.vue';

export default Vue.extend({
  name: 'Block',
  components: {
    AttributeCheckboxes,
    BCard,
    FilterInput,
    ObjectTypeDropdown,
    RelatedFilters,
  },
  props: {
    value: {
      type: Object as () => Block,
      required: true,
    },
    first: {
      type: Boolean,
      required: true,
    },
  },
  computed: {
    ...mapGetters(['exportableObjects', 'modelMeta']),
  },
  methods: {
    ...mapActions({
      loadEmptyBlock: 'export/loadEmptyBlock',
    }),
    update(propName: string, newValue: object) {
      this.$emit('input', {
        ...this.value,
        [propName]: newValue,
      });
    },
    async changeObjectType(newType: string) {
      const newBlock = await this.loadEmptyBlock(newType);
      this.$emit('input', newBlock);
    },
  },
});
